// extracted by mini-css-extract-plugin
export var cartContainer = "_n1-4";
export var gray = "_n1-1";
export var itemContainer = "_n1-2";
export var itemDetails = "_n1-3";
export var strong = "_n1-0";